var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSofa(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons/icons-category/hotel") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/icons-category/hotel",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-sleeper-chair",
    transform: "translate(3.000000, 5.000000)",
    fill: "#0D6EFD"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.9375,0 C8.36647734,0 6.25,2.11647734 6.25,4.6875 L6.25,14.0625 C2.81666578,14.0625 0,16.8791656 0,20.3125 C0,22.5476406 1.34771359,24.3032953 3.125,25.4028313 L3.125,32.8125 L3.125,34.375 L3.125,37.5 L6.25,37.5 L6.25,34.375 L34.375,34.375 L34.375,37.5 L37.5,37.5 L37.5,34.375 L37.5,32.8125 L37.5,25.4028313 C39.2772859,24.3032953 40.625,22.5476406 40.625,20.3125 C40.625,16.8791656 37.8083344,14.0625 34.375,14.0625 L34.375,4.6875 C34.375,2.11647734 32.2585234,0 29.6875,0 L10.9375,0 Z M10.9375,3.125 L29.6875,3.125 C30.5539766,3.125 31.25,3.82102266 31.25,4.6875 L31.25,15.0299078 C29.4193984,16.1239938 28.125,18.0395688 28.125,20.3125 L28.125,21.875 L12.5,21.875 L12.5,20.3125 C12.5,18.0395688 11.2056016,16.1239938 9.375,15.0299078 L9.375,4.6875 C9.375,3.82102266 10.0710227,3.125 10.9375,3.125 Z M6.25,17.1875 C7.99479078,17.1875 9.375,18.5677094 9.375,20.3125 L9.375,25 L31.25,25 L31.25,20.3125 C31.25,18.5677094 32.6302094,17.1875 34.375,17.1875 C36.1197906,17.1875 37.5,18.5677094 37.5,20.3125 C37.5,21.6813844 36.6319016,22.807225 35.41565,23.2391359 L34.375,23.6083984 L34.375,31.25 L6.25,31.25 L6.25,23.6083984 L5.20935063,23.2391359 C3.99309875,22.807225 3.125,21.6813844 3.125,20.3125 C3.125,18.5677094 4.50520922,17.1875 6.25,17.1875 Z",
    id: "Shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSofa);
export default __webpack_public_path__ + "static/media/sofa.272d7903e6e44fabe8a46221b0a82b8f.svg";
export { ForwardRef as ReactComponent };